import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "add-worker-modal" }
const _hoisted_2 = { class: "add-worker-modal__search" }
const _hoisted_3 = {
  key: 0,
  class: "add-worker-modal__close"
}
const _hoisted_4 = {
  key: 0,
  class: "add-worker-modal__body-item"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "add-worker-modal__body-department"
}
const _hoisted_7 = { class: "add-worker-modal__body-department-title" }
const _hoisted_8 = ["onClick"]

import {
	computed,
	nextTick,
	onMounted,
	ref
} from "vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { WorkerApi } from "@/ api/WorkerApi";
import { CommonWorkerHolder } from "@/models/interfaces/workers/worker-models";
import { clientPageStore } from "@/store/client-page";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientAddWorkerDropdown',
  props: {
    clientId: {},
    addedWorkers: {},
    showCloseIcon: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $input = ref<typeof AppInput | null>(null)
const $body = ref<HTMLDivElement | null>(null)

const store = clientPageStore()

const isLoading = ref(true)
const filter = ref('')
const holders = ref<CommonWorkerHolder[]>([])

const addedIds = computed(() => new Set((props.addedWorkers || []).map(w => w.Id)))

const filteredHolders = computed<CommonWorkerHolder[]>(() => {
	const query = filter.value.trim().toLowerCase()
	if (!query) return holders.value
	const result: CommonWorkerHolder[] = []
	for (const holder of holders.value) {
		if (holder.IsWorker) {
			if (holder.Worker?.Name?.toLowerCase().includes(query)) {
				result.push(holder)
			}
		} else {
			const dept = holder.Departament
			if (!dept) continue
			if (dept.Name?.toLowerCase().includes(query)) {
				result.push(holder)
			} else {
				const matched = (dept.Workers || []).filter(
					w => w.Name?.toLowerCase().includes(query)
				)
				if (matched.length) {
					result.push({
						...holder,
						Departament: { ...dept, Workers: matched }
					})
				}
			}
		}
	}
	return result
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const onFetchWorkers = async () => {
	try {
		isLoading.value = true
		holders.value = await WorkerApi.getAttachWorkersList(props.clientId)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const isWorkerAdded = (workerId: number) => addedIds.value.has(workerId)

const onAttach = async (workerId: number) => {
	try {
		isLoading.value = true
		await store.attachWorkerToClient(workerId)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const onDetach = async (workerId: number) => {
	try {
		isLoading.value = true
		await store.detachWorkerFromClient(workerId)
	} catch (e) {
		console.error(e)
	} finally {
		isLoading.value = false
	}
}

const onChangeWorkerStage = async (stage: boolean, workerId: number) => {
	if (stage) {
		await onAttach(workerId)
	} else {
		await onDetach(workerId)
	}
}

const onChangeWorkerStageFromName = async (workerId: number) => {
	if (isWorkerAdded(workerId)) {
		await onDetach(workerId)
	} else {
		await onAttach(workerId)
	}
}

onMounted(async () => {
	await onFetchWorkers()
	await nextTick(() => $input.value?.focusInput())
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppInput, {
        ref_key: "$input",
        ref: $input,
        modelValue: filter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
        class: "add-worker-modal__search-input",
        placeholder: "Поиск",
        "show-search-button": ""
      }, null, 8, ["modelValue"]),
      (props.showCloseIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppIcon, {
              name: "close",
              width: "20px",
              color: "#D2D2D2",
              "hover-color": "#499259",
              cursor: "pointer",
              title: "Закрыть",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "add-worker-modal__header" }, [
      _createElementVNode("div", { class: "add-worker-modal__header-title" }, " Сотрудники ")
    ], -1)),
    _createElementVNode("div", {
      class: "add-worker-modal__body",
      ref_key: "$body",
      ref: $body
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredHolders.value, (holder, idx) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
          (holder.IsWorker)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(AppCheckbox, {
                  style: { height: '16px', marginRight: '8px' },
                  value: isWorkerAdded(holder.Worker.Id),
                  text: "",
                  onInput: ($event: any) => (onChangeWorkerStage($event, holder.Worker.Id))
                }, null, 8, ["value", "onInput"]),
                _createElementVNode("div", {
                  class: "add-worker-modal__body-item-text",
                  onClick: ($event: any) => (onChangeWorkerStageFromName(holder.Worker.Id))
                }, _toDisplayString(holder.Worker.Name), 9, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(holder.Departament.Name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(holder.Departament.Workers, (worker) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: worker.Id,
                    class: "add-worker-modal__body-item add-worker-modal__body-item--nested"
                  }, [
                    _createVNode(AppCheckbox, {
                      style: { height: '16px', marginRight: '8px' },
                      value: isWorkerAdded(worker.Id),
                      text: "",
                      onInput: ($event: any) => (onChangeWorkerStage($event, worker.Id))
                    }, null, 8, ["value", "onInput"]),
                    _createElementVNode("div", {
                      class: "add-worker-modal__body-item-text",
                      onClick: ($event: any) => (onChangeWorkerStageFromName(worker.Id))
                    }, _toDisplayString(worker.Name), 9, _hoisted_8)
                  ]))
                }), 128))
              ]))
        ], 64))
      }), 128))
    ], 512)
  ]))
}
}

})